<script setup lang="ts"></script>

<template>
  <v-layout>
    <v-main>
      <NuxtPage :page-key="(route) => route.path" />
    </v-main>
  </v-layout>
</template>

<style></style>
